<template>
<nav class="navbar navbar-expand-md navbar-dark ">
    <a href="/" class="navbar-brand">
      <img src="@/assets/site/ra-text-animated.gif" width="200" />
    </a>
    <button 
      type="button" 
      class="navbar-toggler" 
      data-toggle="collapse" 
      data-target="#navbarCollapse"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarCollapse">
        <div class="navbar-nav">
          <router-link to="dashboard" class="nav-item nav-link">Demos</router-link>
        </div>
        <div class="navbar-nav ml-auto">
          <template v-if="user.loggedIn">
            <a class="nav-item nav-link" @click.prevent="signOut">Sign out</a>
          </template>
          <template v-else>
            <router-link to="login" class="nav-item nav-link">Login</router-link>
            <router-link to="register" class="nav-item nav-link">Register</router-link>
          </template>
        </div>
    </div>
</nav>

</template>

<style scoped>
.nav-item {
  color: white;
}

.nav-item:hover {
  color: greenyellow!important;
}

</style>

<script>
import { mapGetters } from 'vuex'
import { auth } from 'firebase/app';
export default {
  computed: {
    ...mapGetters({
      // map `this.user` to `this.$store.getters.user`
      user: 'user'
    })
  },
  methods: {
    signOut() {
      auth()
        .signOut()
        .then(() => {
          this.$router.replace({
            name: 'home'
          })
        })
    }
  }
}
</script>
